import type {ValueEditorType, ValueEditorTypeMap, ValueEditorTypeOrAlias} from '../types';

export type KpValueEditorForceSettingsMergeStrategy = 'overwrite' | 'merge';

export interface ForceSetting<TYPE extends ValueEditorType = ValueEditorType> {
    type?: ValueEditorTypeOrAlias;
    options: Partial<ValueEditorTypeMap[TYPE]['options']>;
    strategy?: KpValueEditorForceSettingsMergeStrategy;
}

export const ALL_TYPES = 'ALL';
export const DEFAULT_MERGE_STRATEGY: KpValueEditorForceSettingsMergeStrategy = 'overwrite';
